import type { NetworkStatus } from '@sunucupark/client-core';

/** `navigator.onLine` plus the online/offline events, behind the core's port. */
export class BrowserNetworkStatus implements NetworkStatus {
  isOnline(): boolean {
    return navigator.onLine;
  }

  subscribe(listener: (online: boolean) => void): () => void {
    const online = () => listener(true);
    const offline = () => listener(false);
    window.addEventListener('online', online);
    window.addEventListener('offline', offline);
    return () => {
      window.removeEventListener('online', online);
      window.removeEventListener('offline', offline);
    };
  }
}
